<template>
  <div class="d-flex align-items-center">
    <b-button
      v-if="canDownloadApk"
      variant="primary"
      size="sm"
      href="https://api-proc.geolims.com/geoproc-mobile.apk"
      class="download-app-btn mr-1 d-none d-lg-flex align-items-center"
    >
      <feather-icon
        icon="DownloadIcon"
        size="16"
        class="mr-50"
      />
      <span class="font-weight-bold">Download App</span>
    </b-button>

    <b-nav-item-dropdown
      right
      toggle-class="d-flex align-items-center dropdown-user-link"
      class="dropdown-user"
    >
      <template #button-content>
        <div class="d-sm-flex d-none user-nav">
          <p class="user-name font-weight-bolder mb-0">
            {{ displayName }}
          </p>
          <span class="user-status">{{ roleName }}</span>
        </div>
        <b-avatar
          size="40"
          :src="userData.avatar"
          variant="light-primary"
          badge
          class="badge-minimal"
          badge-variant="success"
        >
          <feather-icon
            v-if="!displayName"
            icon="UserIcon"
            size="22"
          />
          <span v-else>{{ initials }}</span>
        </b-avatar>
      </template>

      <div class="dropdown-user-header">
        <b-avatar
          size="46"
          variant="light-primary"
          class="mr-75"
        >
          {{ initials }}
        </b-avatar>
        <div class="dropdown-user-header__copy">
          <strong>{{ displayName }}</strong>
          <span>{{ roleName }}</span>
        </div>
      </div>

      <b-dropdown-item
        link-class="d-flex align-items-center"
        :to="{ path: '/apps/users/profile' }"
      >
        <feather-icon
          icon="UserIcon"
          size="16"
          class="mr-75"
        />
        <span>Profile</span>
      </b-dropdown-item>

      <b-dropdown-divider />

      <b-dropdown-item
        link-class="d-flex align-items-center"
        @click="logout"
      >
        <feather-icon
          icon="LogOutIcon"
          size="16"
          class="mr-75"
        />
        <span>Logout</span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BAvatar, BDropdownDivider, BButton,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BAvatar,
    BDropdownDivider,
    BButton,
  },
  data() {
    return {
      userData: getUserData(),
      avatarText,
    }
  },
  computed: {
    displayName() {
      const name = this.userData?.user_fullname || 'User'
      return name.charAt(0).toUpperCase() + name.slice(1)
    },
    roleName() {
      return this.userData?.UserRoleName || this.userData?.role?.role_name || 'User'
    },
    initials() {
      return this.displayName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part.charAt(0).toUpperCase())
        .join('')
    },
    canDownloadApk() {
      const allowedRoles = [
        'super-admin',
        'purchasing-cabang',
        'laboratory-manager',
        'regional-manager',
        'division-head',
        'fa-coal-manager',
        'operation-director',
        'vice-president',
        'president-director',
      ]
      return allowedRoles.includes(this.userData?.role?.role_slug)
    },
  },
  methods: {
    logout() {
      // 1. Clear all cookies
      this.$cookies.remove('userToken')
      this.$cookies.remove('userData')
      this.$cookies.remove('UserRole') // (Don't forget this one!)
      this.$cookies.remove('userBranch')
      this.$cookies.remove('userPermissions')

      // 2. Delay the redirect by 100ms so Bootstrap can remove the invisible backdrop
      window.location.href = '/login'
    },
  },
}
</script>

<style lang="scss" scoped>
.download-app-btn {
  border-radius: 8px;
  box-shadow: 0 6px 14px rgba(115, 103, 240, 0.22);
}

.dropdown-user {
  ::v-deep .dropdown-menu {
    min-width: 240px;
    padding: 0.35rem;
    border: 0;
    border-radius: 8px;
    box-shadow: 0 12px 34px rgba(34, 41, 47, 0.14);
  }

  ::v-deep .dropdown-item {
    border-radius: 6px;
    padding: 0.65rem 0.8rem;
  }
}

.dropdown-user-header {
  display: flex;
  align-items: center;
  padding: 0.85rem 0.8rem;
  border-bottom: 1px solid rgba(34, 41, 47, 0.08);
  margin-bottom: 0.35rem;
}

.dropdown-user-header__copy {
  display: flex;
  min-width: 0;
  flex-direction: column;

  strong,
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span {
    color: #6e6b7b;
    font-size: 0.82rem;
  }
}
</style>
